import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import '@/styles/index.scss' // global css
import 'element-ui/lib/theme-chalk/index.css';
import 'default-passive-events';
import '@/utils/global.js'
import SlideVerify from 'vue-monoplasty-slide-verify';

import {
  checkIntNumber, ////验证大于0整数
  checkMoney, //验证金额
  hideMobile,// 隐藏手机号
  exportExcelFile,// 导出excel文件
  getInfoLabel,//批量处理标签
} from './utils/index'

Vue.prototype.checkIntNumber = checkIntNumber
Vue.prototype.checkMoney = checkMoney
Vue.prototype.hideMobile = hideMobile
Vue.prototype.exportExcelFile = exportExcelFile
Vue.prototype.getInfoLabel = getInfoLabel
Vue.use(SlideVerify)
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

